/* eslint-disable max-len */

import React from 'react';
import SvgIcon, {SvgIconProps} from '@material-ui/core/SvgIcon';

// Line icon via https://github.com/mapbox/mapbox-gl-draw/blob/master/dist/svg/line.svg
export default function DrawTrackIcon(props: SvgIconProps) {
    return <SvgIcon {...props}>
        <g transform="translate(2,-1031)">
            <path
                style={{
                    color: 'currentColor',
                    display: 'inline',
                    overflow: 'visible',
                    fill: props.style && props.style.color ? props.style.color : 'currentColor',
                    fillRule: 'nonzero',
                    stroke: 'none',
                    strokeWidth: 3,
                    marker: 'none',
                }}
                d="m 13.5,1035.8622 c -1.380712,0 -2.5,1.1193 -2.5,2.5 0,0.3208 0.04614,0.6244 0.15625,0.9063 l -3.75,3.75 c -0.281836,-0.1102 -0.585421,-0.1563 -0.90625,-0.1563 -1.380712,0 -2.5,1.1193 -2.5,2.5 0,1.3807 1.119288,2.5 2.5,2.5 1.380712,0 2.5,-1.1193 2.5,-2.5 0,-0.3208 -0.04614,-0.6244 -0.15625,-0.9062 l 3.75,-3.75 c 0.281836,0.1101 0.585421,0.1562 0.90625,0.1562 1.380712,0 2.5,-1.1193 2.5,-2.5 0,-1.3807 -1.119288,-2.5 -2.5,-2.5 z"
            />
        </g>
    </SvgIcon>;
}
